/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-08 15:28:01
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-17 13:28:33
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/Stock/index.tsx
 */
import React from 'react';
import Stock from '../../Components/Stock/VirtualStock';
import { useDispatch, useSelector } from 'react-redux';
import {
  getStock,
  onStockChange,
  // onSalesChannelAvailableChange,
  // getInventoryUuid,
  // getSalesChannelAvailableQuantity,
  // getCollapse,
  EnumCollapseId,
  // onCollapseChange,
} from '../slice';
//import { checkQuantityAndLeftValid } from 'src/pages/ProductEditor/tools/commonDataCheck';
import SectionHOC from '../HOC';
import { StyledTitle } from 'src/layout/EditorPageLayout/SectionTitle';
import { getI18nFromGeneral } from '@/src/tools/tools';
//import { EnumIds } from 'src/pages/ProductEditor/VirtualProduct/common';

const StockSection = (props) => {
  const { isService } = props;
  // console.log('isService', isService);
  const stock = useSelector(getStock());
  // const inventoryUuid = useSelector(getInventoryUuid());
  const dispatch = useDispatch();
  // const salesChannelAvailableQuantity = useSelector(
  //   getSalesChannelAvailableQuantity(),
  // );

  // const salesChannelAvailableQuantityOpen = useSelector(
  //   getCollapse(EnumCollapseId['sub-salesChannelAvailableQuantity']),
  // );
  // const _onSalesChannelAvailableChange = (data) => {
  //   dispatch(onSalesChannelAvailableChange(data));
  // };

  // const handleOnCollapseChange = (status) => {
  //   dispatch(
  //     onCollapseChange({
  //       status,
  //       id: EnumCollapseId['sub-salesChannelAvailableQuantity'],
  //     }),
  //   );
  // };

  const setData = (data) => {
    dispatch(onStockChange(data));
  };
  return (
    <Stock
      // ids={EnumIds}
      data={stock}
      setData={setData}
      disabled={props.disabled}
      hideCheckbox={!isService}
      // salesChannelAvailableQuantityOpen={salesChannelAvailableQuantityOpen}
      // inventoryUuid={inventoryUuid}
      // checkQuantityAndLeftValid={checkQuantityAndLeftValid}
      //onSalesChannelAvailableChange={_onSalesChannelAvailableChange}
      // salesChannelAvailableQuantity={salesChannelAvailableQuantity}
      // onSubCollapseChange={handleOnCollapseChange}
    />
  );
};
export default SectionHOC(StockSection, {
  id: EnumCollapseId.Quantity,
  title: (
    <StyledTitle
      left={getI18nFromGeneral('general.hOCTitle.quantity')}
      leftBottom={getI18nFromGeneral('general.hOCTitle.quantityBottom')}
    />
  ),

  useCustomCollapseTitle: true,
  useDefaultCollapseContent: true,
});
